module.exports = __webpack_public_path__ + "img/icon-keepkey.c6b6496f.svg";